import { createContext, useContext } from 'react';
import { RootStore } from 'store/rootStore';
import { ProposalItemsStore } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import ProductLineDelegate from 'store/modules/proposal/delegates/productLineDelegate';
import RFQProposalPageStore from './pageStore';

type RFQProposalPageDelegate = ProductLineDelegate<RFQProposalPageStore>;

export const ProductLineDelegateContext = createContext<RFQProposalPageDelegate>(
  new ProductLineDelegate(new RFQProposalPageStore(new ProposalItemsStore(new RootStore())), null),
);

export function useRFQProductLineDelegate(): RFQProposalPageDelegate {
  return useContext(ProductLineDelegateContext);
}
